// components/PageTransition.tsx - 100% Bottom to Top
import { motion, Variants } from "framer-motion";
import { ReactNode } from "react";

const bottomToTopVariants: Variants = {
  initial: { opacity: 0, y: 100 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -100 },
};

interface PageTransitionProps {
  children: ReactNode;
}

const PageTransition = ({ children }: PageTransitionProps) => (
  <motion.div
    variants={bottomToTopVariants}
    initial="initial"
    animate="animate"
    exit="exit"
    transition={{ duration: 0.4, ease: [0.25, 0.46, 0.45, 0.94] }}
    className="w-full h-full"
  >
    {children}
  </motion.div>
);

export default PageTransition;
